import React, { Fragment } from "react";
import {
  CloseMenuArea,
  Navbar,
  NavItem,
  NavWrapper,
  PrimaryExternalLink,
  ExternalLink,
  SectionTitle,
  SocialLinksWrapper,
  SocialLinkItem,
  SocialLinkLabel,
  CategoryHeader,
  IconLink,
} from "../styles";

const DrawerNavigator = ({
  siteNavItems = [],
  socialLinks = [],
  handleClickOutside,
  isOpen,
}) => {
  const totalItems = siteNavItems.reduce((acc, { menuLinkSubSections }) => {
    return (acc += menuLinkSubSections?.length + 1 || 1);
  }, 0);

  const getSectionHeaderElem = ({
    menuLinkLabel,
    menuLinkURL,
    openInNewTab,
  }) => {
    if (menuLinkLabel && menuLinkURL) {
      return (
        <PrimaryExternalLink
          className="primary"
          target={openInNewTab ? "_blank" : "_self"}
          href={menuLinkURL}
        >
          {menuLinkLabel}
        </PrimaryExternalLink>
      );
    }

    return <SectionTitle>{menuLinkLabel}</SectionTitle>;
  };

  const getSubsectionContent = ({ menuSubsectionItems }) => {
    return (
      <>
        {menuSubsectionItems.map(
          (
            {
              menuSubsectionLabel,
              menuSubsectionIcon,
              menuSubsectionURL,
              openInNewTab,
            },
            idx
          ) => {
            return (
              <ExternalLink
                target={openInNewTab ? "_blank" : "_self"}
                href={menuSubsectionURL}
                key={`subsectionMenuItem-${idx}`}
              >
                {menuSubsectionLabel}
              </ExternalLink>
            );
          }
        )}
      </>
    );
  };

  const getMenuSectionContent = ({ menuSectionItems = [] }) => {
    return (
      <>
        {menuSectionItems?.map(
          (
            {
              menuSectionLabel,
              menuSectionIcon,
              menuSectionURL,
              openInNewTab,
              menuSubsectionItems,
            },
            idx
          ) => {
            if (menuSubsectionItems?.length) {
              return (
                <Fragment key={`subNavMenuItem-${idx}`}>
                  <CategoryHeader>{menuSectionLabel}</CategoryHeader>
                  {getSubsectionContent({ menuSubsectionItems })}
                </Fragment>
              );
            }

            return (
              <ExternalLink
                target={openInNewTab ? "_blank" : "_self"}
                href={menuSectionURL}
                key={`subNavMenuItem-${idx}`}
              >
                {menuSectionLabel}
              </ExternalLink>
            );
          }
        )}
      </>
    );
  };

  return (
    <>
      <CloseMenuArea isOpen={isOpen} onClick={handleClickOutside} />
      <Navbar isOpen={isOpen} total_items={totalItems}>
        {siteNavItems?.map(
          (
            {
              menuLinkLabel,
              menuLinkIcon,
              menuLinkURL,
              openInNewTab,
              menuSectionItems,
            },
            index
          ) => (
            <NavWrapper key={`wrapper-${index}`}>
              {getSectionHeaderElem({
                menuLinkLabel,
                menuLinkURL,
                openInNewTab,
              })}
              {menuSectionItems?.length && menuLinkLabel && (
                <NavItem>{getMenuSectionContent({ menuSectionItems })}</NavItem>
              )}
            </NavWrapper>
          )
        ) ?? []}
        <SocialLinksWrapper>
          {socialLinks?.map(
            (
              {
                appBarSocialLinkName,
                appBarSocialLinkIcon,
                appBarSocialLinkUrl,
              },
              index
            ) => (
              <SocialLinkItem key={appBarSocialLinkUrl + index}>
                <ExternalLink href={appBarSocialLinkUrl} target="_blank">
                  <IconLink type={appBarSocialLinkIcon} />
                  <SocialLinkLabel>{appBarSocialLinkName}</SocialLinkLabel>
                </ExternalLink>
              </SocialLinkItem>
            )
          ) ?? []}
        </SocialLinksWrapper>
      </Navbar>
    </>
  );
};

export default DrawerNavigator;
